import * as React from 'react';

function SvgTrashIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 21"
      {...props}>
      <path
        fill="#007BFF"
        d="M7.364.75c-.429 0-.866.153-1.176.469s-.46.761-.46 1.198v.833H0v1.667h.895l1.56 15.078.076.755H15.47l.077-.755 1.56-15.078H18V3.25h-5.727v-.833c0-.437-.15-.882-.46-1.198S11.065.75 10.636.75zm0 1.667h3.272v.833H7.364zm-4.807 2.5h12.886l-1.457 14.166H4.014zm3.17 2.5v9.166h1.637V7.417zm2.455 0v9.166h1.636V7.417zm2.454 0v9.166h1.637V7.417z"
      />
    </svg>
  );
}
export default SvgTrashIcon;
